var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-4",attrs:{"height":"100px"}},[_c('v-col',[_c('img',{staticClass:"productImageSize",attrs:{"src":require("../../assets/gfiMSME.png"),"alt":"logo"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }